import { render, staticRenderFns } from "./forgotten-password.vue?vue&type=template&id=59134454"
import script from "./forgotten-password.vue?vue&type=script&lang=js"
export * from "./forgotten-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports